/* eslint-disable react/no-danger */
import React from 'react';
import { Link } from 'gatsby';
import Slider from 'react-slick';
import { navigate } from '@reach/router';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/it';

function Item({ content, item }) {
  const lang = content.polylang_current_lang;

  return (
    <div>
      {item.type === 'webinar' ?
        <div className="wrapper">
          <div className="intro-slide-item webinar">
            {item.background_image && <img src={item.background_image.source_url} data-src={item.background_image.source_url} alt="" className="lazy-load" />}
            <div className="text-center" dangerouslySetInnerHTML={{ __html: item.description }} />
          </div>
          <a
            className="izi-btn izi-btn-large"
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.button_title}
          </a>
        </div>
        :
        item.type === 'linkedinpost' ?
          <div className="wrapper">
            <div className="intro-slide-item linkedin-post">
              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="item">
                    <div className="wrapper-infos">
                      {item.profile_picture && <img src={item.profile_picture.source_url} className="profile-picture" alt="" />}
                      <div className="author-infos">
                        <div className="author" dangerouslySetInnerHTML={{ __html: item.author }} />
                        <div className="author-position" dangerouslySetInnerHTML={{ __html: item.author_position }} />
                      </div>
                    </div>
                    <div className="description" dangerouslySetInnerHTML={{ __html: item.description + '...' }} />
                  </div>
                </div>
                <div className="col-12 col-md-6" style={{ background: `#031B4A url(${item.background_image ? item.background_image.source_url : null})` }}>
                  <div dangerouslySetInnerHTML={{ __html: item.background_text }} />
                  {item.show_store &&
                  <ul className="store">
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={content.acf.intro_store_apple_url}
                        className="store"
                      >
                        <img src={content.acf.store_apple_image.source_url} alt="App Store" />
                      </a>
                    </li>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={content.acf.intro_store_google_url}
                        className="store"
                      >
                        <img src={content.acf.store_google_image.source_url} alt="Google Store" />
                      </a>
                    </li>
                  </ul>}
                </div>
              </div>
            </div>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={item.url}
              className="izi-btn izi-btn-large"
            >
              {item.button_title}
            </a>
          </div>
          :
          item.type === 'article' ?
            <div className="wrapper">
              <div className="intro-slide-item article">
                <div className="slide-info">
                  <div className="d-flex align-items-center tag-holder">
                    <div className="slide-info-tag">
                      {item.article_category && <div onClick={(e) => navigate(`/${lang}/${lang === 'fr' ? 'blog' : lang === 'it' ? 'il-nostro-blog' : null }`, { state: { cat: item.article_category } })}><span className="category-tag">{item.article_category}</span></div>}
                    </div>
                  </div>
                  <div className="slide-info-text">
                    <Link to={item.url} className="slide-title"><h4>{item.title}</h4></Link>
                    <div className="slide-info-date">
                      {lang === 'fr' ? 'Le ' : null}
                      {lang === 'it' ? 'Il ' : null}
                      {moment(item.article_date).locale(lang).format('DD MMMM YYYY')}
                    </div>
                  </div>
                </div>
                <div className="slide-img">
                  <Link to={item.url} className="post-img">
                    {item.background_image && <img src={item.background_image.source_url} data-src={item.background_image.source_url} alt={item.title} className="lazy-load" />}
                  </Link>
                </div>
              </div>
              <Link to={item.url} className="izi-btn izi-btn-large">{item.button_title}</Link>
            </div>
            : null}
    </div>
  );
}

export default function SectionE({ content }) {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <section className="section-e">
      {content &&
        <div className="container">
          <h2 className="section-title text-center">{content.acf.events_title}</h2>
          {content.acf.event_item_page &&
            <Slider {...settings}>
              {content.acf.event_item_page.map((item) => (
                <Item item={item} content={content} key />
              ))}
            </Slider>}
        </div>}
    </section>
  );
}
